var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wheel-container"},[_c('canvas',{ref:"wheelCanvas",attrs:{"width":"500","height":"500"}}),_c('button',{style:({ backgroundColor: _vm.spinButtonColor }),attrs:{"id":"spin"}},[_vm._v(" "+_vm._s(_vm.spinButtonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }